<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
  export default {
    name: 'App',
    metaInfo: {
      titleTemplate: '%s',
    },
  }
</script>

<style lang="scss">
  .v-application {
    background: #C9C9C9 !important;
  }
  #hero h1 {
    letter-spacing: 4px !important;
  }
  html {
    overflow-x: hidden !important;
    overflow-y: auto !important;
  }
</style>
